import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { sha256 } from 'js-sha256';
import { Subscription } from 'rxjs';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Utils } from 'src/app/core/resources/utils';
import { AuthService } from 'src/app/core/services/authentication.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  companySub: Subscription;
  companyControl = new FormControl('');
  companyValidate: string = '';
  companyOptions: OptionsAutocomplete = { title: 'Cliente', appearance: 'outline', showXMark: true };
  params: {
    [key: string]: {
      hashed: boolean,
      valueToken?: string,
      value?: string,
      defaultToken?: string,
      default?: string
    }
  } = {};

  showSelectorCompany: boolean = false;
  userCompany: string = '';
  holderCompany: string = '';
  dashboard: string;

  constructor(
    private utils: Utils,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService
  ) {
    this.holderCompany = StorageService.checkStorage().getItem('_companyId') || '';
    this.activatedRoute.data.subscribe({
      next: (data) => {
        this.dashboard = data.dashboard;
        this.params = data.params;

        if (!!data.enableSelectorToRoot) {
          this.showSelectorCompany = this.authService.userIsFromRootNit();
        }
        this.showSelectorCompany ?
          this.subscribeCompany() :
          this.userCompany = this.authService.getUserSession().clientCompanyId;
      }
    });
  }

  private subscribeCompany() {
    this.companySub = this.companyControl.valueChanges
      .subscribe(value => {
        if (value && value.companyId) {
          this.userCompany = value.companyId;
          this.companyValidate = 'disable';
        }
        else if (this.userCompany !== '') {
          this.userCompany = '';
          this.companyValidate = 'enable';

        }
      })
  }

  ngOnDestroy() {
    if (this.companySub) this.companySub.unsubscribe();
  }

  private hash(data: string) {
    // @ts-ignore
    const SALT: string = [!+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + ([][(![] + [])[+[]] + (![] + [])[!+[] + !+[]] + (![] + [])[+!+[]] + (!![] + [])[+[]]] + [])[!+[] + !+[] + !+[]] + [!+[] + !+[] + !+[]] + ([][[]] + [])[!+[] + !+[]] + [!+[] + !+[] + !+[] + !+[]] + [+!+[]] + [!+[] + !+[] + !+[] + !+[] + !+[]] + (![] + [])[+!+[]] + (+((+(+!+[] + [+!+[]] + (!![] + [])[!+[] + !+[] + !+[]] + [!+[] + !+[]] + [+[]]) + [])[+!+[]] + [+[] + [+[]] + [+[]] + [+[]] + [+[]] + [+[]] + [+!+[]]]) + [])[!+[] + !+[]] + [+[]] + [+!+[]] + (!![] + [])[!+[] + !+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + (+((+(+!+[] + [+!+[]] + (!![] + [])[!+[] + !+[] + !+[]] + [!+[] + !+[]] + [+[]]) + [])[+!+[]] + [+[] + [+[]] + [+[]] + [+[]] + [+[]] + [+[]] + [+!+[]]]) + [])[!+[] + !+[]] + [!+[] + !+[] + !+[] + !+[]] + [!+[] + !+[] + !+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + (!![] + [])[!+[] + !+[] + !+[]] + (+((+(+!+[] + [+!+[]] + (!![] + [])[!+[] + !+[] + !+[]] + [!+[] + !+[]] + [+[]]) + [])[+!+[]] + [+[] + [+[]] + [+[]] + [+[]] + [+[]] + [+[]] + [+!+[]]]) + [])[!+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + [!+[] + !+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + (![] + [])[+!+[]] + (+((+(+!+[] + [+!+[]] + (!![] + [])[!+[] + !+[] + !+[]] + [!+[] + !+[]] + [+[]]) + [])[+!+[]] + [+[] + [+[]] + [+[]] + [+[]] + [+[]] + [+[]] + [+!+[]]]) + [])[!+[] + !+[]] + (![] + [])[+[]] + (![] + [])[+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + ([][[]] + [])[!+[] + !+[]] + ([][(!![] + [])[!+[] + !+[] + !+[]] + ([][[]] + [])[+!+[]] + (!![] + [])[+[]] + (!![] + [])[+!+[]] + ([![]] + [][[]])[+!+[] + [+[]]] + (!![] + [])[!+[] + !+[] + !+[]] + (![] + [])[!+[] + !+[] + !+[]]]() + [])[!+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + [!+[] + !+[] + !+[]] + [!+[] + !+[] + !+[] + !+[] + !+[] + !+[] + !+[]] + ([][[]] + [])[!+[] + !+[]] + ([][(!![] + [])[!+[] + !+[] + !+[]] + ([][[]] + [])[+!+[]] + (!![] + [])[+[]] + (!![] + [])[+!+[]] + ([![]] + [][[]])[+!+[] + [+[]]] + (!![] + [])[!+[] + !+[] + !+[]] + (![] + [])[!+[] + !+[] + !+[]]]() + [])[!+[] + !+[]];
    return sha256.create().update(`${data}${SALT}`).hex();
  }

  getParamValue(token: string) {
    switch (token) {
      case 'USER_COMPANY':
        return this.userCompany;
      case 'HOLDER_COMPANY':
        return this.holderCompany;
      default:
        return token;
    }
  }

  processParams() {
    let processed = {};
    for (const name in this.params) {
      const param = this.params[name];
      let value = param.value !== undefined ? param.value : this.getParamValue(param.valueToken);

      if (value == '' && !(param.default === undefined && param.defaultToken === undefined)) {
        value = this.utils.isDefined(param.default) ? param.default : this.getParamValue(param.defaultToken);
      }

      processed[name] = param.hashed ? this.hash(value) : value;
    }
    if (Object.keys(processed).length > 0) {
      const params = encodeURIComponent(JSON.stringify(processed));
      return params;
    }
    return '';
  }


  get DASHBOARD_URL(): string {
    const params = this.processParams();
    if (params) {
      return `${this.dashboard}?params=${params}&hl=es`;
    }
    return this.dashboard;
  }

}
